import { CampaignBrief } from "./pages/campaign-brief/components/campaign-brief/campaign-brief.component";

import { CampaignBriefs } from "./pages/campaign-briefs/components/campaign-briefs.component";
import { CampaignBriefsHeader } from "./pages/campaign-briefs/components/campaign-briefs-header.component";

import { ExecutionBrief } from "./pages/execution-brief/components/execution-brief/execution-brief.component";

import { ExecutionBriefList } from "./pages/executions-briefs-list/executions-briefs-list.component";
import { ExecutionBriefListHeader } from "./pages/executions-briefs-list/executions-briefs-list-header.component";

import { FlyerRoutes } from "./pages/flyer/flyer.routes";

import { Support } from "./pages/support/support.component";
import { SupportHeader } from "./pages/support/support-header.component";

import { WorkOrder } from "./pages/work-order/components/work-order/work-order.component";

import { WorkOrderList } from "./pages/work-orders-list/work-orders-list.component";
import { WorkOrderListHeader } from "./pages/work-orders-list/work-orders-list-header.component";

import { IRoute } from "./types/routing/iroute.interface";
import { PAGES } from "./features/navigation/types/pages.constant";
import { getIdPath } from "./features/navigation/types/pages.functions";

export const AppRoutes: IRoute[] = [
  {
    component: CampaignBriefs,
    header: CampaignBriefsHeader,
    path: PAGES.CAMPAIGN_BRIEFS.URL,
  },
  {
    component: CampaignBrief,
    path: getIdPath(PAGES.CAMPAIGN_BRIEF.URL),
  },
  {
    component: ExecutionBriefList,
    header: ExecutionBriefListHeader,
    path: PAGES.EXECUTION_BRIEFS_LIST.URL,
  },
  {
    component: ExecutionBrief,
    path: getIdPath(PAGES.EXECUTION_BRIEF.URL),
  },
  {
    component: WorkOrderList,
    header: WorkOrderListHeader,
    path: PAGES.WORK_ORDERS_LIST.URL,
  },
  {
    component: WorkOrder,
    path: getIdPath(PAGES.WORK_ORDER.URL),
  },
  {
    component: Support,
    header: SupportHeader,
    path: PAGES.SUPPORT.URL,
  },
  ...FlyerRoutes,
];
